module.exports = __webpack_public_path__ + "static/media/chat-icon-search.0f904be6.svg";